import { Routes as AdminRoutes } from '../../app/components/Admin';
import { Routes as SupplierRoutes } from '../../app/components/Supplier';
import { Routes as BuyerRoutes } from '../../app/components/Buyer';

const SillaraRoutes = [];
SillaraRoutes.push(AdminRoutes);
SillaraRoutes.push(SupplierRoutes);
SillaraRoutes.push(BuyerRoutes);
export default SillaraRoutes;
